/* ==========================================================================
   hc-featured-collection — Carousel Controller
   Custom Element + Embla Carousel (all breakpoints)
   Arrow navigation on desktop, touch swipe on mobile
   Pill dot indicators from Embla snap list
   Figma run: r20260311-1430-a
   ========================================================================== */

if (!customElements.get('hc-fc-carousel')) {
  class HcFcCarousel extends HTMLElement {
    constructor() {
      super();
      this.embla = null;
      this.dotNodes = [];
      this.prevBtn = null;
      this.nextBtn = null;
      this.indicator = null;
    }

    connectedCallback() {
      this.prevBtn = this.querySelector('[data-js="prev-btn"]');
      this.nextBtn = this.querySelector('[data-js="next-btn"]');
      this.indicator = this.querySelector('[data-js="indicator"]');

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          if (this.embla) this.embla.scrollPrev();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          if (this.embla) this.embla.scrollNext();
        });
      }

      this.initEmbla();
    }

    disconnectedCallback() {
      this.destroyEmbla();
    }

    /** Activate Embla carousel */
    initEmbla() {
      if (this.embla) return;
      var viewport = this.querySelector('[data-js="viewport"]');
      if (!viewport || typeof EmblaCarousel === 'undefined') return;

      this.embla = EmblaCarousel(viewport, {
        align: 'start',
        containScroll: 'trimSnaps',
        dragFree: true,
        loop: false
      });

      this.embla.on('select', () => {
        this.updateDots();
        this.updateArrows();
      });

      this.embla.on('reinit', () => {
        if (this.indicator) {
          this.buildDots(this.indicator);
        }
        this.updateDots();
        this.updateArrows();
      });

      if (this.indicator) {
        this.buildDots(this.indicator);
      }

      this.updateArrows();
    }

    /** Clean up Embla + dots */
    destroyEmbla() {
      if (this.embla) {
        this.embla.destroy();
        this.embla = null;
      }
      if (this.indicator) this.indicator.innerHTML = '';
      this.dotNodes = [];
    }

    /** Build dot indicators from Embla snap list */
    buildDots(container) {
      if (!this.embla) return;
      var snaps = this.embla.scrollSnapList();
      container.innerHTML = '';
      this.dotNodes = [];

      snaps.forEach((_, i) => {
        var dot = document.createElement('button');
        dot.className = 'hc-featured-collection__dot';
        dot.setAttribute('aria-label', 'Go to product group ' + (i + 1));
        dot.addEventListener('click', () => this.embla.scrollTo(i));
        container.appendChild(dot);
        this.dotNodes.push(dot);
      });

      this.updateDots();
    }

    /** Toggle active dot */
    updateDots() {
      if (!this.embla || !this.dotNodes.length) return;
      var selected = this.embla.selectedScrollSnap();
      this.dotNodes.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === selected);
      });
    }

    /** Enable/disable arrow buttons at boundaries */
    updateArrows() {
      if (!this.embla) return;
      if (this.prevBtn) this.prevBtn.disabled = !this.embla.canScrollPrev();
      if (this.nextBtn) this.nextBtn.disabled = !this.embla.canScrollNext();
    }
  }

  customElements.define('hc-fc-carousel', HcFcCarousel);
}
